import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

interface TipFormActionsProps {
  mode: 'add' | 'edit';
  onDelete?: () => void;
}

export function TipFormActions({ mode, onDelete }: TipFormActionsProps) {
  return (
    <div className="flex justify-between items-center gap-2">
      <Button type="submit">{mode === 'add' ? 'Add Tip' : 'Update Tip'}</Button>
      {mode === 'edit' && onDelete && (
        <Button
          type="button"
          variant="destructive"
          onClick={onDelete}
          className="gap-2"
        >
          <Trash2 className="h-4 w-4" />
          Delete Tip
        </Button>
      )}
    </div>
  );
}